import { SET_FORM_DATA, RESET_FORM } from "./actionTypes";

export const setFormData = (values) => ({
  type: SET_FORM_DATA,
  payload: values,
});

export const resetForm = () => ({
  type: RESET_FORM,
});
